import { FileDesc } from '@wellesley/openapi'
import { MediaUpload, UploadItem } from '../../types'
import { isUpload } from '../mapUpload'

// TODO: discuss size: 0 case with backend
export const isSafeFile = (file: FileDesc) =>
  file.uri && file.meta.height && file.meta.width

export const isSafeFileWithoutSize = (file: FileDesc) => file.uri

const isUploadReady = (item: MediaUpload, allowWithoutSize?: boolean) => {
  if ((item as UploadItem).preview) {
    return true
  }

  if (isUpload(item)) {
    const hasError = item.error
    const hasCompleteFile = item.files.some(
      allowWithoutSize ? isSafeFileWithoutSize : isSafeFile,
    )

    return hasCompleteFile && !hasError
  } else {
    return true
  }
}

export default isUploadReady
